export default {
    path: '/time-logs/:campaign_id?',
    preload: false,
    middlewares: [
        {
            "rms_ui/validatePermissionsMiddleware": [
                ["rms.authenticated"],
                "/login"
            ]
        }
    ]
}
